import { Component, OnInit } from '@angular/core';
import { CompanyInfoStateService } from '../../modules/contact/services/company-info-state.service';

@Component({
  selector: 'app-impressum',
  templateUrl: './app-impressum.component.html',
  styleUrls: ['./app-impressum.component.css']
})
export class PageImpressumDeComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
  }

}
